/* eslint-disable camelcase */
/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable sort-keys */
/* eslint-disable class-methods-use-this */
import encrypt from 'adyen-cse-js/js/adyen.encrypt.nodom.min.js'
import { PACKAGES } from '../../config'

export class AdyenGateway {
  constructor() {
    const key = `${PACKAGES.ADYEN}`
    const options = {}
    this.cseInstance = encrypt.createEncryption( key, options )
  }

  _getCheckoutObject( cartaoCredito ) {
    const exp_month = cartaoCredito.dt_validade.substring( 0, 2 )
    const exp_year = 2000 + parseInt( cartaoCredito.dt_validade.substring( 2 ), 10 )
    return {
      'cvc': cartaoCredito.cvv,
      'expiryMonth': exp_month,
      'expiryYear': exp_year.toString(),
      'generationtime': new Date().toISOString(),
      'holderName': cartaoCredito.nome,
      'number': cartaoCredito.numero
    }
  }

  checkout( cartaoCredito ) {
    const exp_month = cartaoCredito.dt_validade.substring( 0, 2 )
    const exp_year = cartaoCredito.dt_validade.substring( 2 )
    const validateCard = {
      'cvc': cartaoCredito.cvv,
      'month': exp_month,
      'number': cartaoCredito.numero,
      'year': `20${exp_year}`
    }
    if ( this.cseInstance.validate( validateCard ).valid ) {
      const response = {}
      // eslint-disable-next-line no-underscore-dangle
      response.id = this.cseInstance.encrypt( this._getCheckoutObject( cartaoCredito ) )
      response.holder_name = cartaoCredito.nome
      response.last_four_digits = cartaoCredito.numero.substr( -4 )
      response.exp_month = parseInt( exp_month, 10 )
      response.exp_year = parseInt( exp_year, 10 )
      return Promise.resolve( response )
    } else {
      const validationResult = this.cseInstance.validate( validateCard )
      const errors = []
      if ( !validationResult.number ) {
        errors.push( {
          'source': 'numero',
          'message': 'Número Inválido.'
        } )
      }
      if ( !validationResult.cvc ) {
        errors.push( {
          'source': 'cvv',
          'message': 'CVV Inválido.'
        } )
      }
      if ( !validationResult.expiryMonth || !validationResult.expiryYear ) {
        errors.push( {
          'source': 'dt_validade',
          'message': 'Validade Inválida.'
        } )
      }
      return Promise.reject( {
        'source': 'gateway',
        errors
      } )
    }
  }
}
